import EventDescription from "./EventDescription";
import { useState } from "react";
import "../css/HomeEventsPreview.css";
import { useHistory } from "react-router-dom";

function EventCard({ event }) {
  const history = useHistory();

  return (
    <div
      className="event-card"
      onClick={() =>
        history.push(
          event.isExternal
            ? `/evenements/external?eventid=${event._id}`
            : `/evenements/a-venir?eventid=${event._id}`
        )
      }
    >
      {event.image && (
        <div className="event-card-image">
          <img src={event.image} alt={event.title} />
        </div>
      )}
      <div className="event-card-content">
        <h4>{event.title}</h4>
        {event.description_general && (
          <EventDescription className="event-description" value={event.description_general} />
        )}
      </div>
    </div>
  );
}

function HomeEventsPreview({ incomingEvents = [], externalEvents = [] }) {
  const itemsPerPage = 2;
  const [pageIncoming, setPageIncoming] = useState(0);
  const [pageExternal, setPageExternal] = useState(0);

  const visibleIncoming = incomingEvents.slice(
    pageIncoming * itemsPerPage,
    pageIncoming * itemsPerPage + itemsPerPage
  );
  const totalIncomingPages = Math.ceil(incomingEvents.length / itemsPerPage);

  const visibleExternal = externalEvents.slice(
    pageExternal * itemsPerPage,
    pageExternal * itemsPerPage + itemsPerPage
  );
  const totalExternalPages = Math.ceil(externalEvents.length / itemsPerPage);

  return (
    <div className="events-preview-container">
      <div className="events-section">
        <h3>&Eacute;v&eacute;nements &agrave; venir</h3>

        {visibleIncoming.map((event) => (
          <EventCard key={event._id || event.id} event={event} />
        ))}

        {totalIncomingPages > 1 && (
          <div className="pagination-controls">
            <button
              onClick={() => setPageIncoming((p) => Math.max(p - 1, 0))}
              disabled={pageIncoming === 0}
              type="button"
              aria-label="Page precedente"
            >
              &larr;
            </button>

            <span>
              {pageIncoming + 1} / {totalIncomingPages}
            </span>

            <button
              onClick={() =>
                setPageIncoming((p) => Math.min(p + 1, totalIncomingPages - 1))
              }
              disabled={pageIncoming >= totalIncomingPages - 1}
              type="button"
              aria-label="Page suivante"
            >
              &rarr;
            </button>
          </div>
        )}
      </div>

      <div className="events-section">
        <h3>&Eacute;v&eacute;nements &agrave; l'ext&eacute;rieur</h3>

        {visibleExternal.map((event) => (
          <EventCard key={event._id || event.id} event={event} />
        ))}

        {totalExternalPages > 1 && (
          <div className="pagination-controls">
            <button
              onClick={() => setPageExternal((p) => Math.max(p - 1, 0))}
              disabled={pageExternal === 0}
              type="button"
              aria-label="Page precedente"
            >
              &larr;
            </button>

            <span>
              {pageExternal + 1} / {totalExternalPages}
            </span>

            <button
              onClick={() =>
                setPageExternal((p) => Math.min(p + 1, totalExternalPages - 1))
              }
              disabled={pageExternal >= totalExternalPages - 1}
              type="button"
              aria-label="Page suivante"
            >
              &rarr;
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default HomeEventsPreview;
